'use client'

import { Composite, CompositeItem } from '@floating-ui/react'
import { Check } from 'lucide-react'
import { cn } from 'design-system'
import { FC } from 'react'

import { CompositeHTMLProps, FILTER_ITEM_CLASS_NAME } from './constants'
import { SelectFilterConfig } from './types'

type SelectSubFilterProps = {
  config: SelectFilterConfig
  value: string[]
  onChange: (value: string[]) => void
}

export const SelectSubFilter: FC<SelectSubFilterProps> = ({
  config,
  value,
  onChange
}) => {
  const toggleOption = (optionId: string) => {
    const next = value.includes(optionId)
      ? value.filter(v => v !== optionId)
      : [...value, optionId]
    onChange(next)
  }

  return (
    <Composite
      orientation="vertical"
      className="flex max-h-60 flex-col gap-1 overflow-y-auto p-2"
      role="listbox"
      aria-label={config.label}
      aria-multiselectable>
      {config.options.map(option => {
        const checked = value.includes(option.id)
        return (
          <CompositeItem
            key={option.id}
            render={(htmlProps: CompositeHTMLProps) => (
              <button
                {...htmlProps}
                className={cn(FILTER_ITEM_CLASS_NAME, {
                  'bg-blue-100': htmlProps['data-active'] !== undefined
                })}
                role="option"
                aria-selected={checked}
                onClick={() => toggleOption(option.id)}>
                <span
                  className={cn(
                    'flex h-4 w-4 shrink-0 items-center justify-center rounded border',
                    checked
                      ? 'border-blue-600 bg-blue-600'
                      : 'border-slate-300 bg-white'
                  )}
                  aria-hidden>
                  {checked && <Check size={12} className="text-white" />}
                </span>
                <span>{option.label}</span>
              </button>
            )}
          />
        )
      })}
    </Composite>
  )
}
